module.exports = __webpack_public_path__ + "img/18.88320904.jpg";